import { Component } from 'react';
import { connect } from 'react-redux';
import { getLikertOptionColors } from 'lib/blocks';
import { LikertSummaryQuestion } from '.';

const LikertSummary = connect((state) => ({
  messages: state.messages,
  theme: state.theme
}))(
  class extends Component {
    state = {
      reset: 0
    };

    componentDidMount() {
      this.setState({
        reset: 1
      });
      window.addEventListener('resize', this.resetWidth);
    }

    componentWillUnmount() {
      window.removeEventListener('resize', this.resetWidth);
    }

    resetWidth = () => {
      this.setState({
        reset: this.state.reset + 1
      });
    };

    shouldShowPercentage = (questionId, option) => {
      const { task } = this.props;
      const width = document.querySelector(
        `#percentage-bar-label-${task.id}-${questionId}-${option}`
      )?.offsetWidth;
      const percentage = task.questionResponseRates[questionId][option];
      return percentage >= 10 ? width > 40 : width > 30;
    };

    render() {
      const { task, theme } = this.props;
      const { reset } = this.state;

      const likertOptionColors = getLikertOptionColors({
        colormapType: task?.data?.colormap,
        numberOfColors: task?.data?.options?.length || 0,
        theme
      });

      return (
        <div className="summary">
          <div className="options">
            {task.data.options.map((option, j) => {
              return (
                <div className="option" key={j}>
                  <div className="option-icon">
                    <div
                      style={{
                        width: '13px',
                        height: '13px',
                        borderRadius: '50%',
                        backgroundColor: likertOptionColors[j].backgroundColor
                      }}
                    />
                  </div>
                  <div className="option-text">{`${j + 1} = ${option}`}</div>
                </div>
              );
            })}
          </div>

          <div className="questions">
            {task.data.questions.map((question, i) => (
              <LikertSummaryQuestion
                key={i}
                answers={task.answers}
                colormap={task.data.colormap}
                options={task.data.options}
                question={question}
                questionAverages={task.questionAverages}
                questionResponseRates={task.questionResponseRates}
                reset={reset}
                shouldShowPercentage={this.shouldShowPercentage}
                taskId={task.id}
              />
            ))}
          </div>

          <style jsx>{`
            .description {
              color: ${theme.textColorLight};
              font-size: 1.6rem;
              margin-bottom: -10px;
            }
            .options {
              display: flex;
              flex-direction: column;
              padding-left: 10px;
              width: 100%;
            }
            .option {
              color: ${theme.textColorLighter};
              display: flex;
              font-size: 1.4rem;
              font-style: italic;
              font-weight: 600;
              margin-top: 2px;
            }
            .option-icon {
              display: inline-block;
              margin-right: 5px;
              margin-top: 3px;
            }
            .questions {
              counter-reset: likert-questions;
              margin-top: 15px;
            }
          `}</style>
        </div>
      );
    }
  }
);

export default LikertSummary;
